module.exports = __webpack_public_path__ + "img/2.13e29a1c.png";